import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import {Button, Dropdown, Icon} from '@albert-io/atomic';

import './segmented-toolbar-button.scss';

const SegmentedToolbarButton = ({className = '', children, backgroundColor = 'blue'}) => {
  const clonedChildren = React.Children.map(children, (child, i) => {
    return React.cloneElement(child, {
      className: classnames('segmented-toolbar-btn__element', {
        'segmented-toolbar-btn__element--first': i === 0,
        'segmented-toolbar-btn__element--last': i === children.length - 1
      }),
      backgroundColor
    });
  });
  return (
    <div className={`${className} segmented-toolbar-btn u-display_flex`}>{clonedChildren}</div>
  );
};

SegmentedToolbarButton.propTypes = {
  backgroundColor: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string
};

SegmentedToolbarButton.Dropdown = ({
  className,
  children,
  backgroundColor,
  icon = ['fa', 'caret-down'],
  disabled,
  ...rest
}) => {
  const dropdownTrigger = (
    <Button
      size='s'
      className={`${className} segmented-toolbar-btn__dropdown u-height_100pc`}
      color={backgroundColor}
      disabled={disabled}
    >
      {icon ? <Icon icon={icon} /> : null}
    </Button>
  );
  return (
    <Dropdown {...rest} trigger={dropdownTrigger} className='u-height_100pc u-display_flex'>
      {children}
    </Dropdown>
  );
};

SegmentedToolbarButton.Dropdown.propTypes = {
  backgroundColor: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  icon: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  disabled: PropTypes.bool
};

SegmentedToolbarButton.Button = ({onClick, className, text, backgroundColor, ...rest}) => (
  <Button
    size='s'
    className={`${className} segmented-toolbar-btn__button`}
    color={backgroundColor}
    onClick={onClick}
    {...rest}
  >
    {text}
  </Button>
);

SegmentedToolbarButton.Button.propTypes = {
  backgroundColor: PropTypes.string,
  className: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func
};

export default SegmentedToolbarButton;
